/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/guiConfs/guiConfsActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { GuiConfEditForm } from "./GuiConfEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import {GuideProfile} from "../../profile/GuideProfile";
import axios from "axios";

const initGuiConf = {
  id: undefined,
  guideId: 0,
  category: "",
  confTitle: "",
  heldDate: "2020-10-17T04:36:46.479Z",
  location: "",
  remark: "",
  link: "",
  uplaodFile: "",
};
export function GuiConfEdit({
  history,
  match: {
    params: { id,gid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, guiConfForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.guiConfs.actionsLoading,
      guiConfForEdit: state.guiConfs.guiConfForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchGuiConf(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Guide Conference";
    if (guiConfForEdit && id) {
      _title = `Edit Guide Conference`;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guiConfForEdit, id]);

  const saveGuiConf = (values) => {
    if (!id) {
      dispatch(actions.createGuiConf(values)).then(() => backToGuiConfsList());
    } else {
      dispatch(actions.updateGuiConf(values)).then(() => backToGuiConfsList());
    }
  };

  const btnRef = useRef();
  const saveGuiConfClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
  const id1 = id===undefined?'':id
  const GuideUrl = `${process.env.REACT_APP_API_URL}/api/GuiConf/${id1}`;

  const [guide, setGuide] = useState([]);

  useEffect(() => {
    const getGuide = async () => {
      const response = await axios.get(GuideUrl);
      setGuide(response.data);
    };
    getGuide();
  }, [setGuide,GuideUrl]);


  const GuideId = gid?gid:guide.guideId;
 
 
 
  initGuiConf.guideId=GuideId;


  console.log(GuideId)
  const backToGuiConfsList = () => {
    history.push(`/guide/guideprofile`);
  };

  return (
    <div>
      <GuideProfile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToGuiConfsList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveGuiConfClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <GuiConfEditForm
                  actionsLoading={actionsLoading}
                  guiConf={guiConfForEdit || initGuiConf}
                  btnRef={btnRef}
                  saveGuiConf={saveGuiConf}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
